import { render } from "./a.vue?vue&type=template&id=166c4988&lang=pug"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__